import { useEffect } from 'react';

import InsiderService from 'app/services/Insider';

export default function usePushNotifications() {
  useEffect(() => {
    InsiderService.init();
  }, []);
}
